module.exports = __webpack_public_path__ + "static/img/37-中国人民大学附属小学1.38c36e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/37-中国人民大学附属小学1.png
// module id = zTj8
// module chunks = 0